<template>
  <div class="page back-cover">
    <!-- 升华页和海报 -->
    <!-- 蓝图变现实，离不开每个人的拼搏。未来五年，有你有我，拼出精彩！ -->
    <div class="sublime" :style="{opacity: showPoster ? 0 : 1}">
      <div class="icons">
        <div class="icon1"></div>
        <div class="icon2"></div>
        <div class="icon3"></div>
        <div class="icon4"></div>
        <div class="icon5"></div>
        <div class="icon6"></div>
        <div class="icon7"></div>
        <div class="icon8"></div>
      </div>

      <div
        class="texts"
        :style="{transform: `scale(${textsScale})`, wibkitTransform: `scale(${textsScale})`}"
      >
        <img class="texts-anim" src="../assets/sublime/sublime2.jpeg" alt="">
      </div>

      <div
        class="skip-box"
        @click="skipSublime"
      >
        <div class="skip">生成海报</div>
      </div>
    </div>

    <div class="poster">
      <!-- <img v-if="!isTx" src="../assets/backcover/poster.png" alt="" />
      <img v-else src="../assets/backcover/poster-tx.png" alt="" /> -->
      <img v-if="!isTx" src="../assets/backcover/poster.jpg" alt="" />
      <img v-else src="../assets/backcover/poster-tx.jpg" alt="" />
    </div>

    <div class="btns">
      <div class="retry" @click="retry">再看一次</div>
      <div class="share" @click="share">一起拼</div>
      <div class="tip"></div>
    </div>

    <div class="share-box" @click="cancle">
      <div class="share-image"></div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'Sublime',
  data: function ()  {
    return {
      isTx: location.href.indexOf('2021pieces-tx') >= 0,
      textsScale: 1,
      showPoster: false,
      showShare: false
    }
  },
  watch: {
    showPoster () {
      setTimeout(() => {
        document.querySelector('.sublime').style.display = 'none'

        if (window._czc) {
          let tagname = ''
          if (location.href.indexOf('/2021pieces-tx') >= 0) {
            tagname += '-tx'
          }
          window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-海报页', 'pv', '','',''])
        }
      }, 1100)
    },

    showShare (newValue) {
      if (newValue) {
        clearTimeout(this.showShareTimeout)
        // console.log(newValue)
        document.querySelector('.share-box').style.display = 'block'
        
        this.showShareTimeout = setTimeout(() => {
          document.querySelector('.share-box').style.opacity = 1
        }, 100)
      } else {
        clearTimeout(this.showShareTimeout)
        // console.log(newValue)
        document.querySelector('.share-box').style.opacity = 0
        this.showShareTimeout = setTimeout(() => {
          document.querySelector('.share-box').style.display = 'none'
        }, 1100)
      }
    }
  },
  components: {
    // HelloWorld
  },
  beforeMount () {
    this.textsScale = (window.innerWidth / 750).toFixed(2)
  },
  mounted () {
    console.log('sublime mounted')

    // 显示升华页序列帧
    this.showImgs()

    if (window._czc) {
      let tagname = ''
      if (location.href.indexOf('/2021pieces-tx') >= 0) {
        tagname += '-tx'
      }
      window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-升华页', 'pv', '','',''])
    }
  },
  methods: {
    skipSublime () {
      clearTimeout(this.sublimeTimeout)
      
      this.showPoster = true
    },
    showImgs () {
      document.querySelector('.sublime .texts img').classList.add('texts-anim')
      document.querySelector('.sublime .icons').classList.add('icons-anim')
      this.sublimeTimeout = setTimeout(() => {
        this.showPoster = true
      }, 5800)
    },

    // 再看一次
    retry () {
      this.$emit('replay')
    },

    // 显示分享提示
    share () {
      this.showShare = true
    },
    cancle () {
      this.showShare = false
    }
  }
}
</script>

<style lang="scss" scoped>
.back-cover {
  overflow-y: auto;
  // background-color: #ffffff;
  background-color: rgb(95, 208, 168);
  font-size: 0;
}

// 升华页图片序列
.sublime {
  position: fixed;
  z-index: 9;

  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
  // background-image: url(../assets/sublime/1_00044.jpg);
  background-size: 100%;
  transition: opacity 1s ease;
  -webkit-transition: opacity 1s ease;

  .icons {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1px;
    height: 1px;

    & > div {
      position: absolute;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .icon1 {
      top: -16.4rem;
      left: -7.1rem;
      width: 3.36rem;
      height: 2.93rem;
      background-image: url(../assets/sublime/form1@2x.png);
    }
    .icon2 {
      top: -11.1rem;
      left: -13.1rem;
      width: 5.71rem;
      height: 3.81rem;
      background-image: url(../assets/sublime/form2@2x.png);
    }
    .icon3 {
      top: -15.8rem;
      left: 0.3rem;
      width: 2.03rem;
      height: 1.68rem;
      background-image: url(../assets/sublime/form3@2x.png);
    }
    .icon4 {
      top: -17.2rem;
      left: 5.3rem;
      width: 6.05rem;
      height: 3.52rem;
      background-image: url(../assets/sublime/form4@2x.png);
    }
    .icon5 {
      top: -2.5rem;
      left: -7.1rem;
      width: 2.29rem;
      height: 2.37rem;
      background-image: url(../assets/sublime/form5@2x.png);
    }
    .icon6 {
      top: -5.4rem;
      left: 3.8rem;
      width: 3.31rem;
      height: 3.44rem;
      background-image: url(../assets/sublime/form6@2x.png);
    }
    .icon7 {
      top: 5.2rem;
      left: -17.5rem;
      width: 12.51rem;
      height: 10.21rem;
      background-image: url(../assets/sublime/form7@2x.png);
    }
    .icon8 {
      top: 10.4rem;
      left: 4.4rem;
      width: 11.63rem;
      height: 11.81rem;
      background-image: url(../assets/sublime/form8@2x.png);
    }
  }

  .icons-anim {
    animation: rotate 720s linear both infinite;
    -webkit-animation: rotate 720s linear both infinite;
  }

  .texts {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    margin: auto;
    width: 200px;
    height: 920px;
    
    overflow: hidden;
    transform-origin: 100px 460px;
    -webkit-transform-origin: 100px 460px;

    img {
      position: absolute;
      top: 0;
      left: 0;
      // height: 100%;
      width: 7200px;
      height: 920px;
    }
  }

  .texts-anim {
    animation: bgleft 3s steps(1, end) both;
    -webkit-animation: bgleft 3s steps(1, end) both;
  }

  .skip-box {
    position: absolute;
    left: 7rem;
    bottom: .4rem;

    padding-top: .8rem;
    padding-bottom: 8px;
    width: 6rem;
    text-align: center;

    .skip {
      display: inline-block;
      border-bottom: solid 2px #333333;
      padding-bottom: 2px;
      line-height: 1;
      font-size: .8rem;
      color: #333333;
    }
  }
}

@keyframes bgleft {
  0.0%   { left: -0px; }
  2.9%   { left: -200px; }
  5.7%   { left: -400px; }
  8.6%   { left: -600px; }
  11.4%  { left: -800px; }
  14.3%  { left: -1000px; }
  17.1%  { left: -1200px; }
  20.0%  { left: -1400px; }
  22.9%  { left: -1600px; }
  25.7%  { left: -1800px; }
  28.6%  { left: -2000px; }
  31.4%  { left: -2200px; }
  34.3%  { left: -2400px; }
  37.1%  { left: -2600px; }
  40.0%  { left: -2800px; }
  42.9%  { left: -3000px; }
  45.7%  { left: -3200px; }
  48.6%  { left: -3400px; }
  51.4%  { left: -3600px; }
  54.3%  { left: -3800px; }
  57.1%  { left: -4000px; }
  60.0%  { left: -4200px; }
  62.9%  { left: -4400px; }
  65.7%  { left: -4600px; }
  68.6%  { left: -4800px; }
  71.4%  { left: -5000px; }
  74.3%  { left: -5200px; }
  77.1%  { left: -5400px; }
  80.0%  { left: -5600px; }
  82.9%  { left: -5800px; }
  85.7%  { left: -6000px; }
  88.6%  { left: -6200px; }
  91.4%  { left: -6400px; }
  94.3%  { left: -6600px; }
  97.1%  { left: -6800px; }
  100.0% { left: -7000px; }
}

@-webkit-keyframes bgleft {
  0.0%   { left: -0px; }
  2.9%   { left: -200px; }
  5.7%   { left: -400px; }
  8.6%   { left: -600px; }
  11.4%  { left: -800px; }
  14.3%  { left: -1000px; }
  17.1%  { left: -1200px; }
  20.0%  { left: -1400px; }
  22.9%  { left: -1600px; }
  25.7%  { left: -1800px; }
  28.6%  { left: -2000px; }
  31.4%  { left: -2200px; }
  34.3%  { left: -2400px; }
  37.1%  { left: -2600px; }
  40.0%  { left: -2800px; }
  42.9%  { left: -3000px; }
  45.7%  { left: -3200px; }
  48.6%  { left: -3400px; }
  51.4%  { left: -3600px; }
  54.3%  { left: -3800px; }
  57.1%  { left: -4000px; }
  60.0%  { left: -4200px; }
  62.9%  { left: -4400px; }
  65.7%  { left: -4600px; }
  68.6%  { left: -4800px; }
  71.4%  { left: -5000px; }
  74.3%  { left: -5200px; }
  77.1%  { left: -5400px; }
  80.0%  { left: -5600px; }
  82.9%  { left: -5800px; }
  85.7%  { left: -6000px; }
  88.6%  { left: -6200px; }
  91.4%  { left: -6400px; }
  94.3%  { left: -6600px; }
  97.1%  { left: -6800px; }
  100.0% { left: -7000px; }
}

.poster {
  position: relative;
  
  width: 100%;
  font-size: 0;

  img {
    width: 100%;
  }
}

.btns {
  position: fixed;
  bottom: 2.56rem;
  width: 100%;

  .retry, .share {
    position: absolute;
    bottom: 0;
    width: 8.48rem;
    height: 2.56rem;
    background-size: 100%;
    background-repeat: no-repeat;

    line-height: 2.33rem;
    font-size: .83rem;
    color: #ffffff;
  }
  .retry {
    background-image: url(../assets/backcover/retry@2x.png);
    left: 1.08rem;
  }
  .share {
    background-image: url(../assets/backcover/share@2x.png);
    right: .8rem;
  }
  .tip {
    position: absolute;
    left: 5.9467rem;
    bottom: -2rem;

    width: 8.1067rem;
    height: 1.6rem;
    background-image: url(../assets/backcover/but_share_save@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;

    pointer-events: none;
  }
}

.share-box {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  opacity: 0;

  transition: opacity 1s ease;
  -webkit-transition: opacity 1s ease;
  .share-image {
    position: absolute;
    top: .24rem;
    right: .83rem;

    width: 14.45rem;
    height: 9.97rem;
    background-image: url(../assets/backcover/share_tips@2x.png);
    background-size: 100%;
  }
}

@keyframes rotate {
  0%   { transform: rotate(0);}
  100% { transform: rotate(-360deg);}
}
@-webkit-keyframes rotate {
  0%   { -webkit-transform: rotate(0);}
  100% { -webkit-transform: rotate(-360deg);}
}
</style>
